import { useState } from 'react'
import TabChooser from './TabChooser'
import MainPageWrapper from '../../global/components/MainPageWrapper'
import UsersTable from '../tables/UsersTable'
import NewUser from './new-user/NewUser'
import RolesTable from '../tables/Roles/RolesTable'
import NewRole from './new-role/NewRole'
import { OrderContextProvider } from '../../global/context/order-context/OrderContext'

export interface ILocationFilters {
  locationFilter: string
  setLocationFilter: Function
}

interface IUserManagementMainProps {
  tabType?: 'users' | 'roles'
}

function UserManagementMain({ tabType: queueType }: IUserManagementMainProps) {
  const [refetchIndex, setRefetchIndex] = useState(0)

  let table = null
  const isUsersQueue = queueType === 'users'
  const isRolesQueue = queueType === 'roles'

  if (isUsersQueue) {
    table = (
      <UsersTable
        refetchIndex={refetchIndex}
        setRefetchIndex={setRefetchIndex}
      />
    )
  } else if (isRolesQueue) {
    table = (
      <RolesTable
        refetchIndex={refetchIndex}
        setRefetchIndex={setRefetchIndex}
      />
    )
  }

  function incrementRefetchIndex() {
    setRefetchIndex(refetchIndex + 1)
  }

  return (
    <OrderContextProvider>
      <MainPageWrapper
        title='User Management'
        titleFields={
          <div style={{ marginRight: 'auto', marginLeft: '1rem' }}>
            {isUsersQueue ? (
              <NewUser
                setRefetchIndex={incrementRefetchIndex}
                refetchIndex={refetchIndex}
              />
            ) : (
              <></>
            )}
            {isRolesQueue ? (
              <NewRole refetchData={incrementRefetchIndex} />
            ) : (
              <></>
            )}
          </div>
        }
      >
        <TabChooser />
        {table}
      </MainPageWrapper>
    </OrderContextProvider>
  )
}

export default UserManagementMain
